import { useTranslation } from 'react-i18next';

/**
 * Trust strip: the integrations / banking partners we touch. Logos are
 * rendered as wordmarks (text) in a low-contrast monoline style to keep
 * the page calm and to dodge brand-asset licensing pitfalls before
 * production. Replace with real SVGs at GA.
 */
const PARTNERS = [
  'みずほ銀行',
  'SMBC',
  '三菱 UFJ',
  'GMO PG',
  'Stripe',
  'Wise',
  'freee',
  'Money Forward',
  'NetSuite',
  'Xero',
  'QuickBooks',
  'Slack',
  'LINE WORKS',
  'Chatwork',
];

export function LogoMarquee() {
  const { t } = useTranslation();
  const loop = [...PARTNERS, ...PARTNERS];

  return (
    <section className="border-y border-border bg-card/40">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="text-center text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-6">
          {t('landing.partnersEyebrow')}
        </div>
        <div className="overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap items-center">
            {loop.map((name, i) => (
              <div
                key={i}
                className="shrink-0 px-8 text-base md:text-lg font-medium text-muted-foreground/70 tracking-tight"
              >
                {name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
